<template>
<div class="meeting-container">


	<transition name="page-fade" mode="out-in">	
		<div 
			v-if="gridViewIsActive"
			class="flex flex-wrap justify-center items-center fixed top-0 left-0 h-screen w-screen overflow-auto">

			<transition-group 
				name="feed-transition"
				tag="div"
				enter-active-class="animated fadeInUp"
				leave-active-class="animated fadeOut" 
				class="p-6 w-full flex flex-wrap justify-center items-center" ref="tile-wrapper">

				<div v-for="(value, key, index) in roster" :key="index" class="flex items-end justify-end bg-black m-4 mg-filter video-thumbnail relative">
					
					<!-- <div 
						v-addvideoel 
						:data-my-index="index" 
						class="h-full w-full top-0 left-0 absolute mg-filter"></div> -->

					<div class="font-bold text-white mr-3 mb-1">{{index}}</div>
				</div>

			</transition-group>
		</div>
	</transition>

    <div 
		:class="{
			'translate-x-full': gridViewIsActive
		}"
		class="transform mg-ease duration-300 swiper-meeting-participants top-0 right-0 border-0 fixed h-screen p-4 py-10">

		<div class="swiper-button-prev swiper-nav-vertical swiper-nav-vertical-prev"></div>

		<swiper ref="mySwiper" :options="swiperOption" class="h-full">

			<swiper-slide 
			v-for="index in 8" :key="index"
			class="flex items-center justify-center mg-filter video-thumbnail swiper-slide relative">
				<div class="font-bold">
				Slide {{index}}
				</div>
			</swiper-slide>

		</swiper>

		<div class="swiper-button-next swiper-nav-vertical swiper-nav-vertical-next"></div>

    </div>

	<div class="fixed top-0 left-0 m-10" >
		<button @click="gridViewIsActive = !gridViewIsActive">toggle gallery</button>
		<button @click="addVideo">add to gallery</button>
		<button @click="changeSrc">changeSrc</button>
	</div>

</div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            roster: {
                "123": {
                    info: "My info"
                },
                "345": {
                    info: "My info"
                }
            },
            tiles: [],
            gridViewIsActive: true,
            swiperOption: {
                direction: "vertical",
                slidesPerView: "auto",
                slidesPerGroup: 3,
                spaceBetween: 30,
                mousewheel: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            videos: {}
        };
    },
    created() {
        //
    },
    mounted() {
        // window.cool = this.$refs["tile-wrapper"];
        // for (let index = 0; index < 10; index++) {
        //     this.addTile(index);
        // }
    },
    directives: {
        addvideoel: {
            inserted: function(el, binding, vnode) {
                const index = el.getAttribute("data-my-index");
                let video = null;

                if (!index) return;

                video = vnode.context.videos[parseInt(index)];

                if (video) {
                    video.className =
                        "h-full w-full top-0 left-0 absolute object-cover bg-black z-0";
                    el.appendChild(video);
                }
            }
        }
    },
    methods: {
        changeSrc() {
            this.videos[0]["src"] =
                "http://192.168.1.6:8081/assembly-2020_2.h264.mp4";
        },
        addVideoElm() {
            const div = document.querySelector(".add-video-here");
            // div.innerHTML = "OK. abc.";
            div.appendChild(this.videos[0]);
        },
        addVideo() {
            const count = this.tiles.length;
            const video = document.createElement("video");
            const source = document.createElement("source");
            source.src = "http://192.168.1.6:8081/5mb_sample.mp4";
            video.append(source);

            this.videos[count] = video;

            this.tiles.push({});
        },
        addTile() {
            // const slideToAdd = document.createElement("div");
            // const newElement = document.createElement("div");
            // const slideText = document.createElement("div");
            // newElement.className =
            //     "h-full w-full top-0 left-0 absolute object-cover bg-black";
            // slideToAdd.className =
            //     "flex items-end justify-end bg-black m-4 mg-filter video-thumbnail relative";
            // slideText.className = "font-bold text-white mr-3 mb-1";
            // const displayName = `User ${index}`;
            // slideText.innerText = displayName;
            // slideToAdd.appendChild(newElement);
            // slideToAdd.appendChild(slideText);
            // this.tiles.push({});
            // this.$refs["tile-wrapper"].appendChild(slideToAdd);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../styles/views/meeting";
</style>
